import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Security Charge Report</h1>
            <p className="mb-0">List of security charge reports</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/security-charge-report/view-header.js